import {
  CHANGE_PASSWORD_I18N_KEYS
} from '../../../../../features/home/components/constants/i18n/ChangePasswordi18nConstants';

export const CHANGE_PASSWORD_I18N_EN =  {
  [CHANGE_PASSWORD_I18N_KEYS.password_changed_successfully]: "Password changed successfully.",
  [CHANGE_PASSWORD_I18N_KEYS.incorrect_old_password]:        "Old password is incorrect.",
  [CHANGE_PASSWORD_I18N_KEYS.error_changing_password]:       "Error while trying to change password."
}


// WEBPACK FOOTER //
// ./src/locales/en/features/home/components/change_password.i18n.en.js